import { CREATE_TOKEN_STRIPE } from "../types/restaurant.types";
import { deepClone } from "../../utils/utils";

const initialState = {
  infoRestaurant: {
    messageToken: "",
  },
};

const reducer = function restaurantReducer(state = initialState, action) {
  const newState = deepClone(state);
  switch (action.type) {
    case CREATE_TOKEN_STRIPE:
      newState.infoRestaurant.tokenStripeCreated = action.response;
      newState.infoRestaurant.stripe_account_id = action.stripeUserId;
      newState.infoRestaurant.messageToken = action.message;
      return newState;
    default:
      return newState;
  }
};

export default reducer;
